import { Modal, Radio } from 'antd'
import { useDeleteVisitMutation } from '../../domain/jobs/jobsQueries'
import { useEffect, useState } from 'react'
import { useVisitHasTimeEntries } from '../../domain/timeTracking/timeTrackingPeriodQueries'

type Props = {
  visitId: string
  isOpen: boolean
  onClose: () => void
  onDeleted?: () => void
}

const DeleteVisitModal = ({ visitId, isOpen, onClose, onDeleted }: Props) => {
  const [deletePayrollTime, setDeletePayrollTime] = useState(false)
  const hasTimeEntriesQuery = useVisitHasTimeEntries(visitId)
  const deleteMutation = useDeleteVisitMutation()

  useEffect(() => setDeletePayrollTime(false), [isOpen])

  const handleDelete = () => {
    deleteMutation.mutate({ visitId, deletePayrollTime }, { onSuccess: onDeleted })
    onClose()
  }

  return <>
    <Modal
      title='Delete Visit'
      open={isOpen && hasTimeEntriesQuery.data === false}
      onCancel={onClose}
      onOk={handleDelete}
    >
      <p>Are you sure you want to delete this visit?</p>
    </Modal>
    <Modal title="Delete Visit" open={isOpen && hasTimeEntriesQuery.data === true} onCancel={onClose} onOk={handleDelete}>
      <p>There are time entries associated with this visit. What would you like to do with them?</p>
      <Radio.Group value={deletePayrollTime.toString()} onChange={(e) => setDeletePayrollTime(e.target.value === 'true')}>
        <Radio value="false">Mark time entries as unbillable.</Radio>
        <Radio value="true">
          Delete time entries. Crew members will be clocked out for the duration of the visit.
        </Radio>
      </Radio.Group>
    </Modal>
  </>
}

export default DeleteVisitModal